import { Injectable } from "@angular/core";
import { RootStoreState } from "@app/root-store";
import { Store } from "@ngrx/store";
import * as RouterActions from "../actions";

interface EntityRoutePath {
    root: string;
    add: string;
    edit: string;
    list: string;
}

@Injectable({
    providedIn: "root",
})
export class RouterDispatchers {
    go(path: any[]) {
        this.store.dispatch(RouterActions.routerGo({ path }));
    }

    goToEdit(routePath: EntityRoutePath, id: number, dispatch = true) {
        const path = [`${routePath.root}${routePath.edit}`, id];
        if (dispatch) {
            this.store.dispatch(this.getRouterAction(path));
        } else {
            return this.getRouterAction(path);
        }
    }

    goToAdd(routePath: EntityRoutePath, dispatch = true) {
        const path = [`${routePath.root}${routePath.add}`];
        if (dispatch) {
            this.store.dispatch(this.getRouterAction(path));
        } else {
            return this.getRouterAction(path);
        }
    }

    goToList(routePath: EntityRoutePath, dispatch = true) {
        const path = [`${routePath.root}${routePath.list}`];
        if (dispatch) {
            this.store.dispatch(this.getRouterAction(path));
        } else {
            return this.getRouterAction(path);
        }
    }

    getRouterAction(path) {
        return RouterActions.routerGo({ path });
    }

    constructor(private readonly store: Store<RootStoreState.State>) {}
}
